export const CANDIDATE_DETAILS_IT = {
  chat: {
    header: 'Lasciaci i tuoi feedback',
    toggleButton: 'Scrivi a {{ managerName }}',
    toggleButton_open: '$t(candidateDetails.chat.header)',
    toggleCloseHint: 'Chiudi',
    fullScreenButton: 'Tutto schermo',
    sendButtonAriaLabel: 'Invia',
    message: {
      heading:
        '{{ authorFullName }} - $t(common.formatting.date.dateFormat) ore $t(common.formatting.date.dateFormat_time)',
      defaultMessageFeedback:
        'Ciao {{ name }}, se hai qualcosa da comunicarci, usa pure questa chat.',
      defaultMessageFeedback_positive:
        'Ciao {{ name }}, perché <strong>ti interessa</strong>? In fase di colloquio vuoi approfondire alcuni aspetti?',
      defaultMessageFeedback_negative:
        'Ciao {{ name }}, scrivimi le tue motivazioni così potremo perfezionare la ricerca dei candidati.',
    },
  },
  dossier: {
    title: 'Summary & CV',
    subtitle: 'Colloquio',
    button: 'Scarica dossier',
    showCurriculumButton: 'Mostra CV',
    modalTitle:
      '{{ candidateFullName }} | $t(candidate.sections.curriculum.title)',
    modalCloseButtonAriaLabel: 'Chiudi',
  },
  feedback: {
    bubble:
      'Vorresti conoscere meglio {{ candidateFullName }} con un <strong>colloquio</strong>?',
    bubble_interested: '<strong>{{ candidateFullName }}</strong> vi interessa',
    bubble_notInterested:
      '<strong>{{ candidateFullName }}</strong> non vi interessa',
    bubble_discarded: '<strong>{{ candidateFullName }}</strong> non prosegue.',
    actionYes: 'Sì',
    actionNo: 'No',
    actionChangeFeedback: 'Hai cambiato idea?',
    interesting: 'È interessante',
  },
  info: {
    age: '{{ age }} anni',
    drivingTime: {
      hours: '<strong>{{ hours }}</strong>h',
      minutes: '<strong>{{ minutes }}</strong>min',
    },
  },
  intro: {
    editLink: 'Modifica candidatura',
  },
  negativeFeedback: {
    title: 'Perché non è interessante?',
    subtitle:
      'Sapere perché non ritieni idoneo alla posizione questo candidato (es.skills, seniority etc) ci aiuta a presentarti solo candidati perfettamente in linea con le tue aspettative.',
    notesLabel: 'Scrivi la motivazione',
    notesPlaceholder:
      "La motivazione verrà inviata all'head hunter che segue la selezione",
    submit: 'Invia',
    cancel: 'Annulla',
    successTitle: 'Messaggio inviato',
    successSubtitle:
      "Abbiamo inviato la tua valutazione all'head hunter che segue la ricerca.",
    successClose: 'Ok, grazie',
  },
  scout: {
    accordionOpen: 'Apri',
    accordionClose: 'Chiudi',
    title: 'Report scout',
    accordionTitle_skillsAssessment: 'Valutazione delle competenze',
    accordionTitle_overallAssessment: 'Riassunto del ruolo',
    button: 'Scarica report',
  },
};
